import { render, staticRenderFns } from "./BrandCenter.vue?vue&type=template&id=59aeca46&scoped=true&"
import script from "./BrandCenter.vue?vue&type=script&lang=js&"
export * from "./BrandCenter.vue?vue&type=script&lang=js&"
import style0 from "./BrandCenter.vue?vue&type=style&index=0&id=59aeca46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aeca46",
  null
  
)

export default component.exports